import { render, staticRenderFns } from "./home.html?vue&type=template&id=4734bd4a&scoped=true&"
import script from "./home.ts?vue&type=script&lang=ts&"
export * from "./home.ts?vue&type=script&lang=ts&"
import style0 from "./home.scss?vue&type=style&index=0&id=4734bd4a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4734bd4a",
  null
  
)

export default component.exports